import { Create, SimpleForm, NumberInput, ArrayInput, SimpleFormIterator, required } from "react-admin";
import { Grid, Typography } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import EmployeeOrExternalFields from "./Show/EmployeeOrExternalFields";

const CreateAdvancedSpecializations = () => {
  return (
    <Create
      title="Създаване на ВСД"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />

        <Typography
          color="primary"
          sx={{ textAlign: "center", marginTop: "2rem", width: "100%" }}
        >
          Такси
        </Typography>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <NumberInput
              source="fees.documentProcessingFee"
              label="Такса за обработка на документи"
              fullWidth
              validate={[required()]}
              onWheel={e => e.target.blur()}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <NumberInput
              source="fees.dailyTrainingFee"
              label="Такса за дневно обучение"
              fullWidth
              validate={[required()]}
              onWheel={e => e.target.blur()}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <NumberInput
              source="fees.certificateIssueFee"
              label="Такса за издаване на сертификат"
              fullWidth
              validate={[required()]}
              onWheel={e => e.target.blur()}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <NumberInput
              source="fees.duplicateCertificateIssueFee"
              label="Такса за дубликат на сертификат"
              fullWidth
              validate={[required()]}
              onWheel={e => e.target.blur()}
            />
          </Grid>
        </Grid>

        <Typography
          color="primary"
          sx={{ textAlign: "center", marginTop: "2rem", width: "100%" }}
        >
          Преподаватели
        </Typography>
        <ArrayInput
          source="professors"
          label=""
        >
          <SimpleFormIterator inline>
            <EmployeeOrExternalFields
              professorLabel="Преподавател"
              source="professors"
            />
          </SimpleFormIterator>
        </ArrayInput>

        <Typography
          color="primary"
          sx={{ textAlign: "center", marginTop: "2rem", width: "100%" }}
        >
          Ръководители на изпит
        </Typography>
        <ArrayInput
          source="examinationHeads"
          label=""
        >
          <SimpleFormIterator inline>
            <EmployeeOrExternalFields
              professorLabel="Ръководител на изпит"
              source="examinationHeads"
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreateAdvancedSpecializations;
